(function() {
    'use strict';
    Odigeo.UIElements.enhanceRadioGroup = function($formWrapper) {
        if ($formWrapper.attr('data-skip-enhance') === 'true') {
            return $formWrapper;
        }
        $formWrapper.attr({'data-skip-enhance': true});

        $formWrapper.on('setValue', function(evt, value) {
            $formWrapper.find('input[value=' + value + ']').prop('checked', true).trigger('change');
        });

        return $formWrapper;
    };
})();
